<template>
  <div class="password-form d-flex flex-column m-0">
    <div class="d-flex w-100 justify-content-between">
      <label :for="id" class="pull-left pb-1 password-label m-0">
        {{ label }}
      </label>
    </div>
    <div class="w-100 passwordContainer " :class="{ 'is-invalid': error }">
      <input
        class="new-password-input-modal"
        :type="inputType"
        :autocomplete="autocompleteOff ? 'new-password' : 'on'"
        v-bind="{
          id,
          type: inputType,
          value,
          placeholder,
          tabindex,
          autofocus,
          ...inputProps,
        }"
        @input="updateValue"
        @blur="onBlur"
        @focus="onFocus"
      />
      <div class="showPassword">
        <button
          type="button"
          class=" border-0 passwordIcon"
          :class="{ 'is-invalid': error }"
          @click="revealPass"
          @mouseenter="isRevealBtnHovered = true"
          @mouseleave="isRevealBtnHovered = false"
        >
          <AppIcon
            :name="isDangerIconVisible ? 'danger' : revealBtnIcon"
            :fill="isDangerIconVisible ? $scss.errorColor : $scss.textColor"
          />
        </button>
      </div>
    </div>
    <div v-if="forgotPass" class="m-0 pt-1 reset-wrapper-btn">
      <div class="reset-button" @click="openPasswordReset">
        {{ forgotPass }}
      </div>
    </div>
    <span
      v-show="(error, showError)"
      id="passwordHelp"
      class="form-text text-danger error-help"
      >{{ error }}</span
    >
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { prop } from '@/utils/factories';
import AppIcon from '@/components/atoms/Icon';
export default {
  $_veeValidate: {
    name() {
      return this.name;
    },
    value() {
      return this.value;
    },
  },
  components: { AppIcon },
  props: {
    name: prop(String),
    id: prop(String, 'password-input'),
    label: prop(String),
    disabled: prop(Boolean),
    required: prop(Boolean),
    value: prop(String),
    error: prop(String),
    tabindex: prop(Number, -1),
    autofocus: prop(Boolean),
    placeholder: prop(String),
    autocompleteOff: prop(Boolean),
    forgotPass: prop(String),
    inputProps: prop(Object, null),
  },
  data() {
    return {
      inputType: 'password',
      isFocused: false,
      isRevealBtnHovered: false,
      showError: false,
    };
  },
  computed: {
    isDangerIconVisible() {
      return !!this.error && !this.isFocused && !this.isRevealBtnHovered;
    },
    revealBtnIcon() {
      return this.inputType === 'password' ? 'eye_open' : 'eye_close';
    },
  },
  methods: {
    ...mapActions(['openModal', 'closeModal']),
    openPasswordReset() {
      this.openModal({
        name: 'PasswordResetModal',
        settings: {
          variant: 'transparent',
          escKey: false,
          clickOnBackdrop: false,
        },
        // props: {
        //   // email: this.formData.email,
        //   // tokenToSend: res.temporary_token,
        // },
      });
    },
    revealPass() {
      this.inputType = this.inputType === 'password' ? 'text' : 'password';
    },
    updateValue(e) {
      this.$emit('input', e.target.value);
    },
    onFocus() {
      this.$emit('focus');
      this.showError = false;
    },
    onBlur() {
      this.$emit('blur');
      this.showError = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.reset-wrapper-btn {
  align-self: flex-end;
}
.password-form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-family: 'Alexandria', sans-serif;
  width: 100%;
  > .passwordContainer {
    position: relative;
    .showPassword {
      position: absolute;
      top: 22%;
      @include auto-rtl(right, 10px);
      .passwordIcon {
        background: none;
        background-color: transparent;
        height: 100%;
        border-radius: 0.25rem;
      }
    }
    > .new-password-input-modal {
      display: flex;
      padding: 10px 12px 10px 16px;
      align-items: flex-start;
      gap: 10px;
      max-height: 44px;
      width: 100%;
      align-self: stretch;
      color: white;
      border-radius: 6px;
      border: 1px solid rgba(255, 255, 255, 0.06);
      background: rgba(255, 255, 255, 0.04);
      box-shadow: 0px 0px 24px 0px rgba(255, 255, 255, 0.04) inset;
      backdrop-filter: blur(2px);

      > input::placeholder {
        color: var(--opacity-800, rgba(255, 255, 255, 0.9));
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 150% */
        letter-spacing: -0.09px;
      }
    }
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    textarea:-webkit-autofill,
    textarea:-webkit-autofill:hover,
    textarea:-webkit-autofill:focus,
    select:-webkit-autofill,
    select:-webkit-autofill:hover,
    select:-webkit-autofill:focus {
      border: 1px solid rgba(255, 255, 255, 0.06);
      -webkit-text-fill-color: white;
      -webkit-box-shadow: 0px 0px 24px 0px rgba(255, 255, 255, 0.04) inset;
      transition: background-color 5000s ease-in-out 0s;
    }
  }
  .reset-button {
    cursor: pointer;
    &:hover {
      color: #5a58f2;
    }
  }
  > .password-label {
    color: rgba(255, 255, 255, 0.5) !important;
    font-family: 'Alexandria' !important;
    font-size: 14px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    line-height: 24px !important; /* 171.429% */
    letter-spacing: -0.18px !important;
  }
}
</style>
